{
  "v": "4.8.0",
  "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
  "fr": 29.9700012207031,
  "ip": 0,
  "op": 90.0000036657751,
  "w": 100,
  "h": 100,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 1 Outlines 2",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [49.978, 50, 0], "ix": 2 },
        "a": { "a": 0, "k": [50.996, 60.533, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.554, -0.984],
                    [1.17, -0.255],
                    [6.766, -16.432],
                    [-11, -13],
                    [-18, 8],
                    [7.849, 18.952],
                    [0.067, 0.132],
                    [12.928, 0],
                    [5, -14],
                    [-8.877, -8.012],
                    [-0.124, -0.095],
                    [-1.991, 18.916],
                    [7, 3],
                    [-1, -11],
                    [-2.81, -1.887],
                    [-0.482, -0.118],
                    [-0.034, -0.008],
                    [3.816, 2.631],
                    [-0.75, 1.875],
                    [-3.028, -1.81],
                    [-0.234, -0.247],
                    [2.882, -4.803],
                    [6, 1],
                    [0, 8],
                    [-12, 0],
                    [-4.054, -9.919],
                    [-0.045, -0.139],
                    [13.816, -6.035],
                    [0.13, -0.047],
                    [9.89, 5.866],
                    [0.118, 0.082],
                    [-9.963, 16.937],
                    [-15.935, -0.932],
                    [-0.127, -0.015],
                    [2.992, -23.938],
                    [19.892, -5.742],
                    [0.146, -1.698],
                    [0.178, -1.467]
                  ],
                  "o": [
                    [-0.515, 0.96],
                    [-0.588, 1.043],
                    [-16.288, 3.553],
                    [-6, 16],
                    [13, 15],
                    [17.935, -8.967],
                    [-0.057, -0.138],
                    [-6.022, -11.889],
                    [-14, -1],
                    [-3.974, 10.929],
                    [0.116, 0.105],
                    [14.017, 10.793],
                    [1, -8],
                    [-10, -4],
                    [0, 3.76],
                    [0.412, 0.276],
                    [0.033, 0.008],
                    [4.512, 1.059],
                    [-1.113, -0.768],
                    [1.907, -3.814],
                    [0.291, 0.174],
                    [2.873, 3.03],
                    [-3, 6],
                    [-9, -1],
                    [0, -12],
                    [11.919, -0.993],
                    [0.055, 0.135],
                    [4.834, 14.87],
                    [-0.127, 0.056],
                    [-10.866, 3.892],
                    [-0.123, -0.073],
                    [-15.859, -11.033],
                    [7.968, -13.944],
                    [0.129, 0.008],
                    [24.89, 3.1],
                    [-2.87, 22.006],
                    [-1.637, 0.472],
                    [-0.129, 1.491],
                    [0, 0]
                  ],
                  "v": [
                    [-0.996, -58.033],
                    [-1.488, -53.429],
                    [-4.266, -51.41],
                    [-42.496, -21.533],
                    [-35.496, 25.467],
                    [15.504, 36.467],
                    [34.59, -13.326],
                    [34.403, -13.733],
                    [4.504, -33.533],
                    [-27.496, -13.533],
                    [-18.67, 18.311],
                    [-18.309, 18.612],
                    [20.504, 3.467],
                    [9.504, -15.533],
                    [-11.496, -2.533],
                    [-6.035, 5.107],
                    [-4.685, 5.7],
                    [-4.585, 5.724],
                    [-1.477, -1.859],
                    [-2.496, -5.533],
                    [7.073, -6.805],
                    [7.859, -6.168],
                    [10.504, 6.467],
                    [-4.496, 14.467],
                    [-20.496, -3.533],
                    [1.504, -25.533],
                    [27.422, -7.736],
                    [27.573, -7.323],
                    [10.696, 29.384],
                    [10.307, 29.538],
                    [-21.31, 26.578],
                    [-21.674, 26.344],
                    [-32.496, -22.533],
                    [7.311, -42.545],
                    [7.696, -42.51],
                    [45.504, 8.467],
                    [3.394, 49.982],
                    [0.445, 53.597],
                    [0.004, 58.033]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [50.996, 60.533], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 5,
                "s": [0]
              },
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 18,
                "s": [5]
              },
              {
                "i": { "x": [0.833], "y": [1] },
                "o": { "x": [0.167], "y": [0] },
                "t": 27,
                "s": [26]
              },
              {
                "i": { "x": [0.352], "y": [0.632] },
                "o": { "x": [0.203], "y": [0] },
                "t": 48,
                "s": [50]
              },
              {
                "i": { "x": [0.614], "y": [1] },
                "o": { "x": [0.284], "y": [0.273] },
                "t": 67,
                "s": [82.067]
              },
              { "t": 85.000003462121, "s": [100] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.79], "y": [-0.146] },
                "o": { "x": [0.514], "y": [0] },
                "t": 0,
                "s": [0]
              },
              {
                "i": { "x": [0.675], "y": [0.278] },
                "o": { "x": [0.367], "y": [1.095] },
                "t": 18,
                "s": [10.428]
              },
              {
                "i": { "x": [0.589], "y": [1] },
                "o": { "x": [0.286], "y": [0.27] },
                "t": 27,
                "s": [19.979]
              },
              {
                "i": { "x": [0.466], "y": [1] },
                "o": { "x": [0.286], "y": [0] },
                "t": 39,
                "s": [50]
              },
              {
                "i": { "x": [0.576], "y": [0.714] },
                "o": { "x": [0.17], "y": [0] },
                "t": 67,
                "s": [75]
              },
              {
                "i": { "x": [0.836], "y": [1] },
                "o": { "x": [0.408], "y": [0] },
                "t": 78,
                "s": [97.137]
              },
              { "t": 89.0000036250443, "s": [100] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 90.0000036657751,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Layer 1 Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [49.978, 50, 0], "ix": 2 },
        "a": { "a": 0, "k": [50.996, 60.533, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.554, -0.984],
                    [1.17, -0.255],
                    [6.766, -16.432],
                    [-11, -13],
                    [-18, 8],
                    [7.849, 18.952],
                    [0.067, 0.132],
                    [12.928, 0],
                    [5, -14],
                    [-8.877, -8.012],
                    [-0.124, -0.095],
                    [-1.991, 18.916],
                    [7, 3],
                    [-1, -11],
                    [-2.81, -1.887],
                    [-0.482, -0.118],
                    [-0.034, -0.008],
                    [3.816, 2.631],
                    [-0.75, 1.875],
                    [-3.028, -1.81],
                    [-0.234, -0.247],
                    [2.882, -4.803],
                    [6, 1],
                    [0, 8],
                    [-12, 0],
                    [-4.054, -9.919],
                    [-0.045, -0.139],
                    [13.816, -6.035],
                    [0.13, -0.047],
                    [9.89, 5.866],
                    [0.118, 0.082],
                    [-9.963, 16.937],
                    [-15.935, -0.932],
                    [-0.127, -0.015],
                    [2.992, -23.938],
                    [19.892, -5.742],
                    [0.146, -1.698],
                    [0.178, -1.467]
                  ],
                  "o": [
                    [-0.515, 0.96],
                    [-0.588, 1.043],
                    [-16.288, 3.553],
                    [-6, 16],
                    [13, 15],
                    [17.935, -8.967],
                    [-0.057, -0.138],
                    [-6.022, -11.889],
                    [-14, -1],
                    [-3.974, 10.929],
                    [0.116, 0.105],
                    [14.017, 10.793],
                    [1, -8],
                    [-10, -4],
                    [0, 3.76],
                    [0.412, 0.276],
                    [0.033, 0.008],
                    [4.512, 1.059],
                    [-1.113, -0.768],
                    [1.907, -3.814],
                    [0.291, 0.174],
                    [2.873, 3.03],
                    [-3, 6],
                    [-9, -1],
                    [0, -12],
                    [11.919, -0.993],
                    [0.055, 0.135],
                    [4.834, 14.87],
                    [-0.127, 0.056],
                    [-10.866, 3.892],
                    [-0.123, -0.073],
                    [-15.859, -11.033],
                    [7.968, -13.944],
                    [0.129, 0.008],
                    [24.89, 3.1],
                    [-2.87, 22.006],
                    [-1.637, 0.472],
                    [-0.129, 1.491],
                    [0, 0]
                  ],
                  "v": [
                    [-0.996, -58.033],
                    [-1.488, -53.429],
                    [-4.266, -51.41],
                    [-42.496, -21.533],
                    [-35.496, 25.467],
                    [15.504, 36.467],
                    [34.59, -13.326],
                    [34.403, -13.733],
                    [4.504, -33.533],
                    [-27.496, -13.533],
                    [-18.67, 18.311],
                    [-18.309, 18.612],
                    [20.504, 3.467],
                    [9.504, -15.533],
                    [-11.496, -2.533],
                    [-6.035, 5.107],
                    [-4.685, 5.7],
                    [-4.585, 5.724],
                    [-1.477, -1.859],
                    [-2.496, -5.533],
                    [7.073, -6.805],
                    [7.859, -6.168],
                    [10.504, 6.467],
                    [-4.496, 14.467],
                    [-20.496, -3.533],
                    [1.504, -25.533],
                    [27.422, -7.736],
                    [27.573, -7.323],
                    [10.696, 29.384],
                    [10.307, 29.538],
                    [-21.31, 26.578],
                    [-21.674, 26.344],
                    [-32.496, -22.533],
                    [7.311, -42.545],
                    [7.696, -42.51],
                    [45.504, 8.467],
                    [3.394, 49.982],
                    [0.445, 53.597],
                    [0.004, 58.033]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.6235, 0.3294, 0.698, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [50.996, 60.533], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.084], "y": [0] },
                "t": 10,
                "s": [0]
              },
              {
                "i": { "x": [0.735], "y": [0.922] },
                "o": { "x": [0.407], "y": [0] },
                "t": 27,
                "s": [25]
              },
              {
                "i": { "x": [0.764], "y": [1] },
                "o": { "x": [0.921], "y": [0.581] },
                "t": 34,
                "s": [40]
              },
              {
                "i": { "x": [0.279], "y": [1] },
                "o": { "x": [0.167], "y": [0] },
                "t": 44,
                "s": [50]
              },
              { "t": 89.0000036250443, "s": [100] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              { "i": { "x": [0.12], "y": [1] }, "o": { "x": [0.514], "y": [0] }, "t": 0, "s": [0] },
              {
                "i": { "x": [0.466], "y": [1] },
                "o": { "x": [0.286], "y": [0] },
                "t": 34,
                "s": [50]
              },
              { "i": { "x": [0.139], "y": [1] }, "o": { "x": [1], "y": [0] }, "t": 62, "s": [75] },
              { "t": 89.0000036250443, "s": [100] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 90.0000036657751,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
